// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "ymaps3-default-ui-theme.css" + "." + "bec899f3e2f74c23f947" + ".css";
};